import { Config } from '@/config';

import { ApiService } from '@/services/api.service';

export const ContactDirectory = {
  searchContactDirectory({ keywords, page, pageSize, entityType }) {
    const encodedQuery = encodeURIComponent(keywords.join(' '));
    let url = `${Config.api.tender.url}search?query=${encodedQuery}&page=${page}&pageSize=${pageSize}`;
    if (entityType) {
      url += `&entityTypes=${encodeURIComponent(entityType)}`;
    }
    return ApiService.get(url).then((response) => {
      const results = response.data.items;
      const pagination = {
        page: response.data.page,
        totalCount: response.data.totalCount,
        totalPages: response.data.totalPages,
        nextPage: response.data.nextPage,
        previousPage: response.data.previousPage,
      };

      return { results, pagination };
    });
  },
};
